import React from 'react';
import { SITE } from '../data/siteData';
import Icon from '../components/Icon';
import './LegalPage.css';

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <div className="legal-label">Legal</div>
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-sub">Last updated: May 2025</p>
        </div>
      </section>
      <div className="legal-body container">
        <section className="legal-section">
          <h2>1. Information We Collect</h2>
          <p>We collect personal information including your name, contact details, PAN number, Aadhaar details, bank information, and financial goals solely for the purpose of providing financial advisory and investment services.</p>
        </section>
        <section className="legal-section">
          <h2>2. How We Use Your Information</h2>
          <p>Your information is used to: provide personalized financial advisory; facilitate KYC and account opening; send investment reports and updates; comply with SEBI and regulatory requirements; and improve our services.</p>
        </section>
        <section className="legal-section">
          <h2>3. Data Security</h2>
          <p>We implement industry-standard security measures to protect your personal and financial data. All sensitive data is encrypted and stored securely. We do not sell or rent your personal information to third parties.</p>
        </section>
        <section className="legal-section">
          <h2>4. Information Sharing</h2>
          <p>We may share your information with fund houses, insurance companies, banks, and regulatory authorities as required for executing your investments and complying with legal obligations. We do not share your data for marketing purposes without consent.</p>
        </section>
        <section className="legal-section">
          <h2>5. Your Rights</h2>
          <p>You have the right to access, correct, or delete your personal data held by us. You may opt out of marketing communications at any time by contacting us directly.</p>
        </section>
        <section className="legal-section">
          <h2>6. Cookies</h2>
          <p>Our website may use cookies to enhance your browsing experience. You can disable cookies through your browser settings without affecting your ability to use our core services.</p>
        </section>
        <section className="legal-section">
          <h2>7. Contact Us</h2>
          <p>For privacy-related queries, please contact:<br/>
          📞 {SITE.contact.phone}<br/>
          ✉ {SITE.contact.email}<br/>
          📍 {SITE.contact.address}</p>
        </section>
      </div>
    </div>
  );
}
